// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a746b89a","455":"f402e7b2","977":"d9267a9d"}[chunkId] + ".chunk.js";
};